import {Box, Stack, Typography} from '@mui/material';
import {MainHeader, StepProgressBar} from 'presentation/components';
import {CustomStepper} from 'presentation/components/CustomStepper';
import {PlanTypeEnum} from 'presentation/constants/bookingTypesEnum';
import {GuideStep, stepMap} from 'presentation/modules/guide/shared/constants/constants';
import {MOBILE_STEPS_LABELS} from 'presentation/modules/guide/shared/constants/mobileStepLabels';
import {SearchBarUnit} from 'presentation/modules/guide/shared/ui/components/SearchBarUnit';
import React from 'react';
import {useHealthGuideHeader} from './hooks/useHealthGuideHeader';
import {HealthGuideHeaderProps} from './types';

export const HealthGuideHeader = ({allProviders}: HealthGuideHeaderProps) => {
	const {stepLabels, handleBack, handleClose, isMobile, currentStepState, getNetworkTitle} =
		useHealthGuideHeader();

	return (
		<MainHeader
			title={getNetworkTitle()}
			handleBack={handleBack}
			handleClose={handleClose}
			variant="subRoute"
			hideProfileMenu={true}>
			<Stack gap={isMobile ? 1 : 3} px={isMobile ? 2 : 3} pb={isMobile ? '12px' : '20px'}>
				<Box maxWidth={647}>
					{isMobile ? (
						<StepProgressBar
							mt={1}
							currentStep={
								currentStepState
									? stepMap[currentStepState as GuideStep].active + 1
									: 1
							}
							totalSteps={stepLabels.length}
						/>
					) : (
						<CustomStepper
							activeStep={
								currentStepState ? stepMap[currentStepState as GuideStep].active : 0
							}
							stepLabels={stepLabels}
						/>
					)}
				</Box>
				{isMobile ? (
					<Typography variant="body1" fontSize="1.125rem">
						{currentStepState
							? MOBILE_STEPS_LABELS[currentStepState as GuideStep]
							: MOBILE_STEPS_LABELS[GuideStep.LOCATION]}
					</Typography>
				) : null}
			</Stack>
			{currentStepState === GuideStep.RESULTS ? (
				<SearchBarUnit type={PlanTypeEnum.HEALTH} providers={allProviders} />
			) : null}
		</MainHeader>
	);
};
